import React from 'react';
import ReactGA from 'react-ga';

import { AchievementCacheResolver, AchievementInfoCacheResolver, AchivementFindById } from 'api/achievementAPICall';
import { StatCacheResolver } from 'api/statAPICall';
import ApplicationEvents from 'components/applicationEvents';
import { ViewAppIdIcon, ViewItemProgress } from 'components/commonAssets';
import { SimplePagerView } from 'components/generics';
import { ViewAchievementAppFilterEditor } from 'components/marketAppFilterEditor';
import { _I_ } from 'components/translate';
import { ViewAchievementUnlockProgress } from 'components/unlockProgress';
import { ViewUserFriendsList } from 'components/userFriendsList';
import { ViewAchievementUserSearch } from 'components/userSearchFilter';
import { LogStream } from 'generics/common';
import { loadCurrentApp, storeCurrentApp } from 'generics/routed.js';
import { SettingsInjections } from 'generics/settingsInjections';
import { classMixer, objectMap } from 'generics/utils';

LogStream.enable("VIEWMARKETEDITEMSLIST");

class ViewMarketedItem extends React.Component {
  render() {
    const { item, handler, compare } = this.props;
    let descProgressDiv = 1;

    if (item.desc.meta && item.desc.meta.descProgressDiv)
      descProgressDiv = item.desc.meta.descProgressDiv;

    const localization = item.desc.localization !== undefined ? item.desc.localization : {
      "name": item.desc.name
    };

    const iconUrl = item.desc.iconUrl || "images/broken_item.png";

    const state = getUnlockState(item);
    const unlockClass = state.unlocked ? "" : "locked";

    // Compare item
    let compareTimestamp, compareUnlocked, compareUnlockClass, compareCurrent;
    if (compare !== undefined) {
      const compareState = getUnlockState(compare);
      compareTimestamp = compare.timestamp;
      compareUnlocked = compareState.unlocked;
      compareUnlockClass = compareUnlocked ? "" : "locked";
      compareCurrent = Math.floor(compareState.current / descProgressDiv);
      //compareGoal = compareState.goal;
    }

    let statInfo = null;

    if (item.stat !== undefined) {
      const itemStatOpened = parseInt(item.stat.opened * 100);
      statInfo = (
        <span className="item-stat-opened">
          {_I_("ViewItemSearch.globalstat.opened")}
          {itemStatOpened}
          {_I_("ViewItemSearch.globalstat.ofGamers")}
        </span>
      );
    }

    const current = Math.floor(state.current / descProgressDiv);
    const goal = Math.floor(state.goal / descProgressDiv);

    return (
      <div className="view-marketed-backdrop">
        <div className="view-marketed-item" onClick={handler}>
          <img className={classMixer("item-icon", unlockClass)} src={iconUrl} />
          <div className="item-desc">
            <div className="item-name">
              <span className="item-name-bold">{localization.name} {statInfo}</span><br />
              {localization.description}<br />
            </div>
            <div className="item-progress">
              <ViewItemProgress current={current}
                goal={goal}
                timestamp={item.timestamp} />

              <ViewItemProgress current={compareCurrent}
                goal={goal}
                timestamp={compareTimestamp}
                hidden={!compare} />
            </div>
          </div>
          <img className={classMixer("item-icon", compareUnlockClass, (!!compare ? "" : "hidden"))} src={iconUrl} />
        </div>
      </div>
    );
  };
}

// { "appid", "hash_name", "name", "icon", "color" }
class ViewAchivementList extends React.Component {

  selectItem(item) {
    //ApplicationEvents.emit_async( "achievement.setCurrentAssetByHash", item.appid, item.hash_name );
  }

  render() {
    const { indexShift, accessLimited, comparenick, usernick } = this.props;
    const itemsData = this.props.items;
    const items = Object.keys(itemsData).slice(indexShift, indexShift + this.props.pagesize);
    const compareItems = this.props.compare;

    if (accessLimited) {
      return (
        <div className="ViewMarketedItemsList">
          <div className="text-center">
            <div><h1 className="glyphicon glyphicon-ban-circle" /></div>
            <div>{_I_("ViewItemSearch.limitedAccess")}</div>
          </div>
        </div>);
    }
    else if (items.length == 0) {

      const isCompare = comparenick && comparenick != usernick;
      const emptyMessage = isCompare ? _I_("ViewItemSearch.stub.emptyCompare_1") + comparenick +
        _I_("ViewItemSearch.stub.emptyCompare_2") : _I_("ViewItemSearch.stub.empty");

      return (
        <div className="ViewMarketedItemsList">
          <div className="text-center">
            <div><h1 className="glyphicon glyphicon-question-sign" /></div>
            <div>{emptyMessage}</div>
          </div>
        </div>);
    }

    return (
      <div className="ViewMarketedItemsList">
        {
          items.map((aid) => (<ViewMarketedItem
            key={`i_${indexShift}_${aid}`}
            itemId={aid}
            handler={() => this.selectItem(itemsData[aid])}
            item={itemsData[aid]}
            compare={compareItems[aid]}
          />))

        }
      </div>);
  }
};

export function getUnlockState(item) {
  let state = {
    current: 0,
    goal: 1,
    unlocked: false
  };

  if (item.progress !== undefined) {
    state.current = item.progress;
    state.goal = item.desc.stages[item.stage].progress;
  }
  else {
    state.goal = item.desc.stages[item.stage - 1].progress;
    state.current = state.goal;
  }

  state.unlocked = (state.goal == state.current);

  return state;
}

export class ViewUserAchievement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      "foundItems": [],
      "compareItems": [],
      "totalItems": 0,
      "skip": 0,
      "words": "[]",
      "selectedApp": null,
      "selectedTagsMap": {},
      "sortOrder": "",
      "accessLimited": false
    };

    this.PAGESIZE = 15;

    this.setResolvedItems = (assets) => { this.processItems(assets); }
    this.onLoadAchievements = (assets) => { this.searchItems(); }
    this.resolveFoundItems = (appid, items) => this.resolveItems(appid, items);
    this.setCurrentAppId = (appid) => { this.toggleAppFilter(appid) }
  }

  searchItems() {
    const userid = this.props.userid;
    const apps = this.state.selectedApp;
    const language = SettingsInjections.getUsedLocale().name;

    if (!apps)
      return;

    AchievementCacheResolver.resolve(
      apps, userid
    ).then((assets) => {
      LogStream("VIEWMARKETEDITEMSLIST").info("searchItems -> ", assets);

      const assetsList = Object.keys(assets);

      // resolveItems
      return this.resolveFoundItems(apps, assets).then((items) => {
        this.setResolvedItems(items); // processItems
        return assetsList;
      });
    }).catch((reason) => {
      const error = reason.details.response.error;
      if (error == 'BLOCKED_DUE_TO_NON_FRIEND' || error == 'BLOCKED_DUE_TO_PRIVATE') {
        this.setState({
          "foundItems": [],
          "compareItems": [],
          "totalItems": 0,
          "skip": 0,
          "accessLimited": true,
        });

        return;
      }

      this.setState({
        "foundItems": [],
        "compareItems": [],
        "totalItems": 0,
        "skip": 0,
        "accessLimited": false,
      });

      reason = Object.assign({}, reason,
        {
          "caption": "Search Item Error",
          "message": ("Failed to search market for items:\n" +
            reason.message)
        });

      LogStream("VIEWMARKETEDITEMSLIST").error("searchItems - Failed (", reason, ")");
    }).then((assets) => {
      AchievementInfoCacheResolver.resolve(
        apps, language
      ).then((achievements) => {
        const visibleAchievements = Object.keys(achievements).filter((achievementId) => {
          if (achievements[achievementId]['meta'] && !achievements[achievementId]['meta']['achievement'])
            return false;

          return assets.includes(achievementId);
        });
        const totalItems = visibleAchievements.length;
        this.setState({ totalItems });
      });
    });
  }

  async resolveItems(appid, items) {
    return Promise.all([
      StatCacheResolver.resolve(appid), // Get global stat for appid
      ...objectMap(items,
        (itemState, itemId) => AchivementFindById(appid, itemId)
      )]
    ).then((itemsInfo) => {
      const itemsStat = itemsInfo.shift();

      Object.keys(items).forEach((itemId) => {
        const itemInfo = itemsInfo.filter((achievement) => (achievement && achievement.name === itemId))[0];
        const itemStat = itemsStat[itemId];

        if (!itemInfo || itemInfo.name === undefined)
          delete items[itemId];
        else {
          items[itemInfo.name].desc = itemInfo;
          items[itemInfo.name].stat = itemStat;
        }
      });

      console.log('resolveAchivements', items);

      return items;
    })
  }

  processItems(assets) {
    const apps = this.state.selectedApp;
    const { userid, loggedUser } = this.props;

    if (!userid || userid == loggedUser) {
      this.setState({ "foundItems": assets, "compareItems": [], accessLimited: false });
    }
    else {
      // Get achievement for compare
      AchievementCacheResolver.resolve(
        apps, loggedUser
      ).then((loggedAssets) => {
        LogStream("VIEWMARKETEDITEMSLIST").info("searchItems for compare -> ", loggedAssets);

        // resolveItems
        this.resolveFoundItems(apps, loggedAssets).then((items) => {
          this.setState({
            "foundItems": assets,
            "compareItems": loggedAssets,
            accessLimited: false
          });
        });
      }).catch((reason) => {
        this.setState({
          "foundItems": [],
          "compareItems": [],
          accessLimited: false
        });

        reason = Object.assign({}, reason,
          {
            "caption": "Search Achievements Error",
            "message": ("Failed to search achievements:\n" +
              reason.message)
          });

        LogStream("VIEWMARKETEDITEMSLIST").error("searchItems for compare - Failed (", reason, ")");
      });
    }
  }

  canGoForward() {
    return Object.keys(this.state.foundItems).length > this.state.skip + this.PAGESIZE;
  }


  canGoBackward() {
    return this.state.skip > 0;
  }


  onPageForward() {
    if (!this.canGoForward())
      return;

    this.setState({ "skip": this.state.skip + this.PAGESIZE })
  }


  onPageBackward() {
    if (!this.canGoBackward())
      return;

    let skip = this.state.skip - this.PAGESIZE;
    if (skip <= 0)
      skip = 0;
    this.setState({ "skip": skip });
  }

  componentDidMount() {
    ReactGA.pageview('achivementlist');

    ApplicationEvents.on("achievement.loadAchievements", this.onLoadAchievements);
    ApplicationEvents.on("achievement.setCurrentAppId", this.setCurrentAppId);

    const appIds = (this.props.appIds || []).map(it => +it).filter(it => it > 0);
    const lruAppId = +(loadCurrentApp());
    const currentAppId = (appIds.length == 1) ? appIds[0] : lruAppId;

    if ((currentAppId > 0) && (appIds.indexOf(currentAppId) >= 0)) {
      this.toggleAppFilter(currentAppId, null);
      return;
    }
  }

  componentWillUnmount() {
    ApplicationEvents.off("achievement.loadAchievements", this.onLoadAchievements);
    ApplicationEvents.off("achievement.setCurrentAppId", this.setCurrentAppId);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevState.selectedApp != this.state.selectedApp) ||
      (prevProps.userid != this.props.userid)) {
      this.searchItems();
    }
  }

  toggleAppFilter(selectedApp) {
    if (selectedApp == this.state.selectedApp) {
      return; // no updates
    }

    storeCurrentApp(selectedApp);
    this.setState({ "skip": 0, selectedApp });
  }

  onChangeUID(uID, nick) {
    this.setState({ "skip": 0 });
    ApplicationEvents.emit_async("achievement.setCurrentUserById", uID, nick);
  }

  renderCurrentSearchTerms() {
    const terms = this.renderAppTerms();
    const heading = this.state.selectedApp ? _I_("ViewItemSearch.heading.resultsFor") : _I_("ViewItemSearch.heading.selectGame");

    return (
      <div className="ViewItemSearchTerms">
        <div className="view-marketed-search-heading">{heading}</div>
        <div className="view-marketed-search-terms">{terms}</div>
      </div>
    );
  }

  renderAppTerms() {
    if (this.state.selectedApp) {
      return <ViewAppIdIcon appId={this.state.selectedApp} compact />;
    }

    return [];
  }

  renderTotalProgress() {
    const { foundItems, compareItems, totalItems, accessLimited } = this.state;

    let unlockedCount = 0;
    let unlockedCompareCount = 0;

    Object.keys(foundItems).forEach((itemKey) => {
      let state = getUnlockState(foundItems[itemKey]);

      if (state.unlocked)
        unlockedCount++;
    });

    Object.keys(compareItems).forEach((itemKey) => {
      let state = getUnlockState(compareItems[itemKey]);

      if (state.unlocked)
        unlockedCompareCount++;
    });

    return (
      <ViewAchievementUnlockProgress
        total={totalItems}
        unlocked={unlockedCount}
        unlockedCompare={unlockedCompareCount}
        usernick={this.props.usernick}
        comparenick={this.props.currentnick}
        limited={accessLimited} />
    );
  }

  renderSearchPanel() {
    return (
      <div className="ViewItemSearchPanel">
        <ViewAchievementAppFilterEditor
          selectedApp={this.state.selectedApp}
          selectedTagsMap={this.state.selectedTagsMap}
          appIds={this.props.appIds}
          onUpdate={(appId) => this.toggleAppFilter(appId)}
        />

        <ViewAchievementUserSearch
          onUpdate={(uID, nick) => this.onChangeUID(uID, nick)}
          usernick={this.props.currentnick}
        />

        <ViewUserFriendsList
          userid={this.props.loggedUser}
          appIds={this.props.appIds}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="ViewItemSearch">
        {this.renderCurrentSearchTerms()}
        <div className="MainBlock">
          <div className="ResultsSection">
            {this.renderTotalProgress()}

            <ViewAchivementList
              items={this.state.foundItems}
              compare={this.state.compareItems}
              indexShift={this.state.skip}
              accessLimited={this.state.accessLimited}
              pagesize={this.PAGESIZE}
              usernick={this.props.usernick}
              comparenick={this.props.currentnick}
            />

            <SimplePagerView
              disableBack={!this.canGoBackward()}
              disableForward={!this.canGoForward()}
              onClickBack={() => { this.onPageBackward(); }}
              onClickForward={() => { this.onPageForward(); }}
              currentPosition={1 + Math.floor(this.state.skip / this.PAGESIZE)}
              arrowsWithIndexes
            />
          </div>
          {this.renderSearchPanel()}
        </div>
      </div>
    )
  }
}